import '../../site/plugins/kirby3-cookie-banner/dist/assets/cookie-banner-DSt9AXzp.js';

import ProjectTeaser from "./components/project-teaser";
import ButtonCookie from "./components/button-cookie.js";

import BarbaJs from "./features/barba-js";
new BarbaJs();

document.documentElement.classList.replace('no-js', 'js');
